import { render, staticRenderFns } from "./TechTitle.vue?vue&type=template&id=2d0abe68&scoped=true&"
import script from "./TechTitle.vue?vue&type=script&lang=js&"
export * from "./TechTitle.vue?vue&type=script&lang=js&"
import style0 from "./TechTitle.vue?vue&type=style&index=0&id=2d0abe68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0abe68",
  null
  
)

export default component.exports